<template>
  <v-flex xs12 sm6 md4 class="pa-2">
    <v-card class="widget-card">
      <v-card-text class="pa-0">
        <v-container class="pa-0">
          <div class="layout row ma-0 justify-center align-center">
            <div class="sm4 xs4 flex">
              <div class="layout column ma-0 justify-center align-center">
                <v-icon size="48px" color="primary">{{ stat.icon }}</v-icon>
              </div>
            </div>
            <div class="layout column ma-0 justify-center">
              <span class="caption">{{ stat.subtitle }}</span>
              <div class="headline">{{ stat.title }}</div>
              <span class="caption">{{ prefix }} {{ stat.suffix }}</span>
            </div>
          </div>
        </v-container>
      </v-card-text>
    </v-card>
  </v-flex>
</template>
<script>
export default {
  name: "Stat",
  props: {
    stat: {
      type: Object,
    },
    prefix: {
      type: String,
    },
  },
};
</script>

<style scoped>
.widget-card {
  box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.21);
  background-color: transparent;
}
</style>
